import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-professional-bodies-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-professional-bodies-wams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../shared/models/alert";
import { CreateApplicationProfessionalBodiesWamsConstants } from "./create-application-professional-bodies-wams.constants";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { RecipientService } from "../../../../shared/components/recipient-components/shared/shared-services/recipient.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
export let CreateApplicationProfessionalBodiesWamsComponent = class CreateApplicationProfessionalBodiesWamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    recipientService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    professionalBodiesForm;
    professionalBodiesFormControlName = CreateApplicationProfessionalBodiesWamsConstants.PROFESSIONAL_BODY_FORM_CONTROL_NAME;
    markImplementingAgentAsRequiredLabel = CreateApplicationProfessionalBodiesWamsConstants.MARK_IMPLEMENTING_AGENT_AS_REQUIRED_LABEL;
    markImplementingAgentAsRequiredFormControlName = CreateApplicationProfessionalBodiesWamsConstants.MARK_IMPLEMENTING_AGENT_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToImplementingAgentLabel = CreateApplicationProfessionalBodiesWamsConstants.COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_LABEL;
    copyApplicantDetailsToImplementingAgentFormControlName = CreateApplicationProfessionalBodiesWamsConstants.COPY_APPLICANT_DETAILS_TO_IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    markEngineerAsRequiredLabel = CreateApplicationProfessionalBodiesWamsConstants.MARK_ENGINEER_REQUIRED_LABEL;
    markEngineerAsRequiredFormControlName = CreateApplicationProfessionalBodiesWamsConstants.MARK_ENGINEER_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = CreateApplicationProfessionalBodiesWamsConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    copyApplicantDetailsToEngineerFormControlName = CreateApplicationProfessionalBodiesWamsConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    markElectricalContractorAsRequiredLabel = CreateApplicationProfessionalBodiesWamsConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_LABEL;
    markElectricalContractorAsRequiredFormControlName = CreateApplicationProfessionalBodiesWamsConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorLabel = CreateApplicationProfessionalBodiesWamsConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL;
    copyApplicantDetailsToContractorFormControlName = CreateApplicationProfessionalBodiesWamsConstants.COPY_APPLICANT_DETAILS_TO_CONTRACTOR_FORM_CONTROL_NAME;
    implementingAgentFormControlName = CreateApplicationProfessionalBodiesWamsConstants.IMPLEMENTING_AGENT_FORM_CONTROL_NAME;
    engineerFormControlName = CreateApplicationProfessionalBodiesWamsConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = CreateApplicationProfessionalBodiesWamsConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    showImplementingAgent = false;
    showEngineer = false;
    showElectricalContractor = false;
    implementingAgentDisableFilterBy = true;
    implementingAgentDisableEditing = false;
    implementingAgentShowFields = true;
    implementingAgentGroups = [];
    implementingAgentLabel = CreateApplicationProfessionalBodiesWamsConstants.IMPLEMENTING_AGENT_LABEL;
    implementingAgentShowGroupsDropdown = false;
    implementingAgentIsRequiredChecked = false;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = CreateApplicationProfessionalBodiesWamsConstants.ENGINEER_LABEL;
    engineerShowGroupsDropdown = false;
    engineerIsRequiredChecked = false;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = CreateApplicationProfessionalBodiesWamsConstants.ELECTRICAL_CONTRACTOR_LABEL;
    contractorShowGroupsDropdown = false;
    contractorIsRequiredChecked = false;
    applicant;
    componentName = CreateApplicationProfessionalBodiesWamsConstants.COMPONENT_NAME;
    savedImplementingAgent;
    savedEngineer;
    savedContractor;
    constructor(applicationCreateService, recipientService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.recipientService = recipientService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.getMetadata();
        this.getApplicantData();
    }
    ngOnInit() {
        this.initForm();
        this.initialiseDefaultValues();
        this.getProBodiesData();
    }
    loadMetadata(stepMeta) {
        try {
            this.implementingAgentGroups = stepMeta.implementingAgentConsultantGroup;
            this.engineerGroups = stepMeta.engineerGroup;
            this.contractorGroups = stepMeta.responsibleContractorGroup;
            this.changeDetectorRefs.markForCheck();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get(this.professionalBodiesFormControlName);
        form.clearValidators();
        form.updateValueAndValidity();
        this.professionalBodiesForm = form;
    }
    onMarkImplementingAgentAsNotApplicableChecked(event) {
        const implementingAgentIsRequired = event.target.checked;
        if (implementingAgentIsRequired) {
            this.showImplementingAgent = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).enable();
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
            this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).setValue(true);
            this.implementingAgentIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).disable();
            this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).setValue(false);
            this.showImplementingAgent = false;
            this.changeDetectorRefs.detectChanges();
            this.implementingAgentIsRequiredChecked = false;
        }
    }
    onMarkEngineerAsRequired(event) {
        const engineerIsRequired = event.target.checked;
        if (engineerIsRequired) {
            this.showEngineer = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.engineerFormControlName).enable();
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(true);
            this.engineerIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.engineerFormControlName).disable();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
            this.showEngineer = false;
            this.changeDetectorRefs.detectChanges();
            this.engineerIsRequiredChecked = false;
        }
    }
    onMarkElectricalContractorAsRequired(event) {
        const contractorIsRequired = event.target.checked;
        if (contractorIsRequired) {
            this.showElectricalContractor = true;
            this.changeDetectorRefs.detectChanges();
            this.professionalBodiesForm.get(this.contractorFormControlName).enable();
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
            this.contractorIsRequiredChecked = true;
        }
        else {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.contractorFormControlName).disable();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
            this.showElectricalContractor = false;
            this.changeDetectorRefs.detectChanges();
            this.contractorIsRequiredChecked = false;
        }
    }
    onCopyApplicantToImplementingAgent($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.implementingAgent > 0 && this.selectedApplication.implementingAgent[0].id >= 0) ? this.selectedApplication.implementingAgent[0].id : 0;
            applicantData.groups = this.implementingAgentGroups;
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
        }
    }
    onCopyApplicantToEngineer($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.engineer > 0 && this.selectedApplication.engineer[0].id >= 0) ? this.selectedApplication.engineer[0].id : 0;
            applicantData.groups = this.engineerGroups;
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
        }
    }
    onCopyApplicantToElectricalContractor($event) {
        const copyApplicantDataChecked = $event.target.checked;
        if (copyApplicantDataChecked) {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            const applicantData = this.applicant;
            applicantData.id = (this.selectedApplication.electricalContractor > 0 && this.selectedApplication.electricalContractor[0].id >= 0) ? this.selectedApplication.electricalContractor[0].id : 0;
            applicantData.groups = this.engineerGroups;
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(applicantData);
        }
        else {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
        }
    }
    syncProfBodiesIsRequiredCheckBoxes(selectedApplication) {
        this.syncImplementingAgentIsRequiredCheckBoxes(selectedApplication);
        this.syncEngineerIsRequiredCheckBoxes(selectedApplication);
        this.syncConstructorIsRequiredCheckBoxes(selectedApplication);
        this.professionalBodiesForm.markAsDirty();
        this.changeDetectorRefs.detectChanges();
    }
    syncImplementingAgentIsRequiredCheckBoxes(selectedApplication) {
        const implementingAgentNotRequired = selectedApplication?.implementingAgentNa;
        if (implementingAgentNotRequired) {
            this.implementingAgentIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).disable();
            this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).setValue(false);
            this.showImplementingAgent = false;
        }
        else {
            this.showImplementingAgent = true;
            this.implementingAgentIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
            this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).setValue(true);
        }
    }
    syncEngineerIsRequiredCheckBoxes(selectedApplication) {
        const engineerIsNotRequired = selectedApplication?.engineerNa;
        if (engineerIsNotRequired) {
            this.implementingAgentIsRequiredChecked = false;
            this.showEngineer = false;
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.engineerFormControlName).disable();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showEngineer = true;
            this.engineerIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(true);
        }
    }
    syncConstructorIsRequiredCheckBoxes(selectedApplication) {
        const contractorIsNotRequired = selectedApplication?.contractorNa;
        if (contractorIsNotRequired) {
            this.contractorIsRequiredChecked = false;
            this.showElectricalContractor = false;
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(null);
            this.professionalBodiesForm.get(this.contractorFormControlName).disable();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showElectricalContractor = true;
            this.contractorIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
        }
    }
    populateProfessionalBodiesForms() {
        const selectedApplication = this.selectedApplication;
        this.populateImplementingAgent(selectedApplication);
        this.populateEngineer(selectedApplication);
        this.populateElectricalContractor(selectedApplication);
    }
    populateImplementingAgent(selectedApplication) {
        const implementingAgentControl = this.professionalBodiesForm.get(this.implementingAgentFormControlName);
        if (selectedApplication.implementingAgentNa) {
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
            this.showImplementingAgent = false;
            this.implementingAgentIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showImplementingAgent = true;
            this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).setValue(true);
            this.implementingAgentIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.implementingAgentFormControlName).reset();
            if (this.savedImplementingAgent.length > 0) {
                const implementingAgent = this.savedImplementingAgent[0];
                implementingAgent.groups = this.implementingAgentGroups;
                implementingAgent.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                implementingAgentControl.setValue(implementingAgent);
            }
        }
    }
    populateEngineer(selectedApplication) {
        const engineerControl = this.professionalBodiesForm.get(this.engineerFormControlName);
        if (selectedApplication.engineerNa) {
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            this.showEngineer = false;
            this.engineerIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showEngineer = true;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
            this.engineerIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.engineerFormControlName).reset();
            if (this.savedEngineer.length > 0) {
                const engineer = this.savedEngineer[0];
                engineer.groups = this.engineerGroups;
                engineer.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                engineerControl.setValue(engineer);
            }
        }
    }
    populateElectricalContractor(selectedApplication) {
        const contractorControl = this.professionalBodiesForm.get(this.contractorFormControlName);
        if (selectedApplication.contractorNa) {
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            this.showElectricalContractor = false;
            this.contractorIsRequiredChecked = false;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
        }
        else {
            this.showElectricalContractor = true;
            this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(true);
            this.contractorIsRequiredChecked = true;
            this.professionalBodiesForm.get(this.contractorFormControlName).reset();
            if (this.savedContractor.length > 0) {
                const contractor = this.savedContractor[0];
                contractor.groups = this.contractorGroups;
                contractor.groups.forEach(group => {
                    if (group?.hasOwnProperty("requiredFields")) {
                        delete group.requiredFields;
                    }
                });
                contractorControl.setValue(contractor);
            }
        }
    }
    getProBodiesData() {
        if (this.selectedApplication) {
            const implementingAgentID = this.selectedApplication.implementingAgentId;
            const engineerID = this.selectedApplication.engineerId;
            const contractorID = this.selectedApplication.contractorId;
            if (implementingAgentID || engineerID || contractorID) {
                this.getProfessionalBodiesId(implementingAgentID, engineerID, contractorID);
            }
        }
    }
    getProfessionalBodiesId(implementingAgentID, engineerID, contractorID) {
        const implementingAgentParams = {
            $expand: "groups", $filter: `id eq ${implementingAgentID}`
        };
        const engineerParams = {
            $expand: "groups", $filter: `id eq ${engineerID}`
        };
        const contractorParams = {
            $expand: "groups", $filter: `id eq ${contractorID}`
        };
        forkJoin([
            this.recipientService.getRecipientsObservable(implementingAgentParams),
            this.recipientService.getRecipientsObservable(engineerParams),
            this.recipientService.getRecipientsObservable(contractorParams)
        ]).subscribe({
            next: (professionalBodies) => {
                if (professionalBodies[0]?.length > 0) {
                    // implementingAgent
                    this.savedImplementingAgent = professionalBodies[0];
                }
                if (professionalBodies[1]?.length > 0) {
                    // Engineer
                    this.savedEngineer = professionalBodies[1];
                }
                if (professionalBodies[2]?.length > 0) {
                    // contractor
                    this.savedContractor = professionalBodies[2];
                }
                if (this.professionalBodiesForm.pristine || professionalBodies.length > 0) {
                    this.syncProfBodiesIsRequiredCheckBoxes(this.selectedApplication);
                    this.populateProfessionalBodiesForms();
                }
                else {
                    this.showProfBodiesBasedOnCurrentFormStatus();
                }
                this.changeDetectorRefs.detectChanges();
            }, error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    showProfBodiesBasedOnCurrentFormStatus() {
        const implementingAgentIsRequired = this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).value;
        const engineerIsRequired = this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).value;
        const contractorIsRequired = this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).value;
        if (implementingAgentIsRequired) {
            this.showImplementingAgent = true;
        }
        else {
            this.showImplementingAgent = false;
        }
        if (engineerIsRequired) {
            this.showEngineer = true;
        }
        else {
            this.showEngineer = false;
        }
        if (contractorIsRequired) {
            this.showElectricalContractor = true;
        }
        else {
            this.showElectricalContractor = false;
        }
        // this.changeDetectorRefs.detectChanges();
    }
    getApplicantData() {
        if (this.selectedApplication) {
            const applicantID = this.selectedApplication.applicantId;
            if (applicantID) {
                this.getApplicantByApplicantId(applicantID);
            }
        }
    }
    getApplicantByApplicantId(applicantID) {
        const params = {
            $expand: "groups", $filter: `id eq ${applicantID}`
        };
        this.recipientService.getRecipientsObservable(params).pipe(take(1)).subscribe({
            next: (recipients) => {
                if (recipients.length > 0) {
                    const savedApplicant = recipients[0];
                    this.applicant = savedApplicant;
                }
            }, error: (error) => {
                this.appController.handleServerErrorMessage(this.componentName, error, CRUDOperation.Get);
            }
        });
    }
    initialiseDefaultValues() {
        this.professionalBodiesForm.get(this.markImplementingAgentAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: RecipientService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationProfessionalBodiesWamsComponent = __decorate([
    Component({
        selector: "app-create-application-professional-bodies-wams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationProfessionalBodiesWamsComponent);
